enum EAppFontFamilies {
  ATLAS_BLACK = 'Atlas-AAA-Black',
  ATLAS_LIGHT = 'Atlas-AAA-Light',
  ATLAS_REGULAR = 'Atlas-AAA-Regular',
  ATLAS_500 = 'Atlas-AAA-Medium',
  ATLAS_BOLD = 'Atlas-AAA-Bold',
}

export { EAppFontFamilies }
